namespace Core {

    class UniqueSellingPoint {

        icon:string;
        title:string;
        text:string;
        modal:string;

        constructor(private modalService:any, private $location:ng.ILocationService) {
            this.autoLaunch();
        }

        launchModal ()  {
            if (this.modal !== '') {
                this.modalService.launch( this.modal );
            }
        }

        autoLaunch() {
            const usp = this.$location.search().usp;

            if (usp && this.modal !== '' && this.modal.indexOf('/') > 0) {
                if(usp === this.modal.split('/').pop()) {
                    this.launchModal();
                }
            }
        }

    }

    angular
        .module('core')
        .directive('uniqueSellingPoint', () => {
            return {
                restrict: 'E',
                replace: true,
                controller: UniqueSellingPoint,
                controllerAs: 'usp',
                scope : {},
                bindToController: {
                    icon: '@',
                    title: '@',
                    text : '@',
                    modal : '@'
                },
                templateUrl: 'partials/home/directivetemplate?type=UniqueSellingPoint'
            };
        });
}
